
###
Generic factory class that can be injected into an angular router using
    @factory 'whateverFactoryName', ->
        return new Factory('app::Angular/Path/To/Models')
###
class exports.Factory

    constructor: (@model_path) ->
        @cache = {}

    make: (type, props = {}, strict_props = true) =>
        # create an instance
        cls = @_getClass(type)
        if typeof cls isnt 'function'
            throw new Error("'#{type}' isn't a constructor (looking in #{@model_path})")

        # if we get a model instance, just use it. Don't overwrite properties.
        if props instanceof cls
            obj = props
        else
            # create new object
            obj = new cls()

            # set the properties
            # unless _require_predefined_props is set, set only predefined properties
            if obj._require_predefined_props isnt false
                for k, v of props
                    # and don't override any class methods!
                    if obj.hasOwnProperty(k) and typeof obj[k] isnt 'function'
                        obj[k] = v
            else
                # this could use _.assign or _.assignIn instead?
                for k, v of props
                    obj[k] = v

        return obj

    _getClass: (type) =>
        # check the cache first for performance
        if @cache[type]?
            return @cache[type]

        # load the class
        # TODO: this really needs to be more robust, but it works for now
        cls = App.loadClass "#{@model_path}/#{type}"

        # cache it for future use
        @cache[type] = cls

        return cls
